<template>
    <div class="form-group">
        <label>Pay with</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text input-icon">
                    <i class="fa fa-credit-card"></i>
                </span>
            </div>
            <select v-model="payment"
                    :class="['custom-select', error ? 'is-invalid' : '']">
                <option v-if="isEcocashZwgEnabled && currency === 'ZWG'" value="ecocash">EcoCash</option>
                <option v-if="isEcocashUsdEnabled" value="ecocash-usd">EcoCash USD</option>
                <option v-if="isStripeEnabled" value="stripe">International Card</option>
            </select>
            <div v-text="error" class="invalid-feedback"/>
        </div>
    </div>
</template>

<script>
import { paymentMethods, systems } from '../../core/data/global';

export default {
    props: {
        payment: {
            type: String,
            default: ''
        },
        currency: {
            type: String,
            default: 'ZWG'
        },
        error: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            internalPayment: this.payment
        };
    },
    computed: {
        enabledMethods() {
            return paymentMethods;
        },
        isEcocashZwgEnabled() {
            return systems.ecocash_payment && systems.ecocash_zwg_payment;
        },
        isEcocashUsdEnabled() {
            return systems.ecocash_payment && systems.ecocash_usd_payment;
        },
        isEcocashEnabled() {
            return this.isEcocashZwgEnabled || this.isEcocashUsdEnabled;
        },
        isStripeEnabled() {
            return this.enabledMethods.includes('stripe');
        }
    },
    watch: {
        payment(newVal) {
            this.internalPayment = newVal;
        },
    },
    methods: {
        updatePayment() {
            this.$emit('update:payment', this.internalPayment);
        },
    },
}
</script>
